const SEMVER_PATTERN=/^v?(\d+)\.(\d+)\.(\d+)(?:-([0-9A-Za-z.-]+))?$/;

export function parseGameVersion(value){
  const match=SEMVER_PATTERN.exec(String(value||'').trim());
  if(!match)return null;
  return {
    major:Number(match[1]),
    minor:Number(match[2]),
    patch:Number(match[3]),
    prerelease:match[4]||'',
  };
}

export function normalizeGameVersion(value){
  const parsed=parseGameVersion(value);
  if(!parsed)return null;
  const base=`${parsed.major}.${parsed.minor}.${parsed.patch}`;
  return parsed.prerelease?`${base}-${parsed.prerelease}`:base;
}

function comparePrerelease(first,second){
  if(first===second)return 0;
  if(!first)return 1;
  if(!second)return -1;
  const firstParts=first.split('.');
  const secondParts=second.split('.');
  const length=Math.max(firstParts.length,secondParts.length);
  for(let index=0;index<length;index+=1){
    const a=firstParts[index];
    const b=secondParts[index];
    if(a===undefined)return -1;
    if(b===undefined)return 1;
    if(a===b)continue;
    const aNumeric=/^\d+$/.test(a);
    const bNumeric=/^\d+$/.test(b);
    if(aNumeric&&bNumeric)return Number(a)<Number(b)?-1:1;
    if(aNumeric!==bNumeric)return aNumeric?-1:1;
    return a.localeCompare(b)<0?-1:1;
  }
  return 0;
}

export function compareGameVersions(first,second){
  const a=parseGameVersion(first);
  const b=parseGameVersion(second);
  if(!a||!b)return null;
  for(const key of ['major','minor','patch']){
    if(a[key]!==b[key])return a[key]<b[key]?-1:1;
  }
  return comparePrerelease(a.prerelease,b.prerelease);
}

export function isGameVersionAtLeast(version,minimum){
  const comparison=compareGameVersions(version,minimum);
  return comparison!==null&&comparison>=0;
}
